import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTv, faSearch } from '@fortawesome/free-solid-svg-icons';

const TopNavbar = () => {
  const navigateToDonations = () => {
    window.location.href = '/donations';
  };

  return (
    <div className="top-navbar">
      <FontAwesomeIcon icon={faTv} className='icon' onClick={navigateToDonations}/>
      <h2>Following  |   <span>For You</span></h2>
      <FontAwesomeIcon icon={faSearch} className='icon' onClick={navigateToDonations}/>
    </div>
  );
};

export default TopNavbar;
